import { spacing } from '@scality/core-ui';
import { Box, CopyButton } from '@scality/core-ui/dist/next';
import { Marked, type Tokens } from 'marked';
import { useMemo } from 'react';
import CODEBLOCK_LANGS from '../../gen/codeblock-langs.json';
import type { ClientChatResponse } from '../../types/ClientMessage';
import { FeedbackButtons } from './FeedbackButtons';
import { GUARDIAN_MARKED_COMPONENTS } from './GuardianMarkdown';
import RetryMessage from './RetryMessage';

function escapeHtml(text: string): string {
  return text.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
}

function codeRenderer({ text, lang }: Tokens.Code): string {
  if (lang === 'mermaid') {
    return '';
  }

  if (lang && CODEBLOCK_LANGS.includes(lang)) {
    return `<pre><code class="language-${lang}">${escapeHtml(text)}</code></pre>`;
  }

  const componentName = (lang ?? '').replace(/^json\+/, '').trim();
  if (componentName && componentName in GUARDIAN_MARKED_COMPONENTS) {
    return '';
  }

  const langAttr = lang ? ` class="language-${lang}"` : '';
  return `<pre><code${langAttr}>${escapeHtml(text)}</code></pre>`;
}

export const marked = new Marked({ renderer: { code: codeRenderer } });

export const InlineActionButtonGroup: React.FC<{
  message: ClientChatResponse;
  isLastResponse: boolean;
  isThinking?: boolean;
}> = ({ message, isThinking = false, isLastResponse = false }) => {
  const htmlContent = useMemo(() => marked.parse(message.content) as string, [message.content]);

  return (
    <Box display="flex" justifyContent="end" gap={spacing.r8}>
      {isLastResponse && !isThinking && <FeedbackButtons messageTimestamp={message.timestamp.toISOString()} />}
      {isLastResponse && <RetryMessage />}
      {!isThinking && <CopyButton textToCopy={htmlContent} label={'answer'} copyAsHtml />}
    </Box>
  );
};
